import '@aws-amplify/ui-react/styles.css';
import './App.scss';
import { AppProvider } from './providers/AppProvider';

function App() {
    return (
        <div className='App'>
            <AppProvider />
        </div>
    );
}

export default App;
